const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReduce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 38,
    viewBox: "0 0 40 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.0576 15.0751C36.3992 6.76379 29.0738 0.5 20.2846 0.5C13.5322 0.5 7.6403 4.19946 4.52246 9.68703",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55859 22.2017C4.21697 30.513 11.5424 36.7768 20.3316 36.7768C27.1683 36.7768 33.1186 32.9865 36.2062 27.3909",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2335 3.9638C14.1395 5.66542 14.3492 7.95731 13.0065 9.77569C11.3568 12.0092 7.27459 12.9584 4.98054 14.5584C3.28108 15.7433 2.24108 18.3422 2.24108 18.3422C2.24108 18.3422 -1.88 10.0416 3.21405 3.97677C5.11027 1.72164 8.61081 0.601638 11.2162 1.97245L12.0486 2.47839",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.704 33.4557C26.0034 31.9206 25.904 29.7238 27.2834 28.1C29.5991 25.3757 32.5785 25.2568 34.9504 24.1389C37.4456 22.9606 38.4769 19.6222 38.4769 19.6222C38.4769 19.6222 42.2326 27.9617 37.1061 33.9854C35.1904 36.2341 31.8218 37.3952 28.7213 36.1735C28.2304 35.979 27.7245 35.5508 27.4694 35.3173",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4864 16.6622H22.0248L22.8875 6.74438L13.1318 20.6125H18.5935L17.7308 30.5282L27.4864 16.6622Z",
    stroke: "white",
    style: {
      stroke: "white",
      strokeOpacity: 1
    },
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReduce);
export default __webpack_public_path__ + "static/media/icon-reduce.c060c212cdfe13e93f3b792bc265336a.svg";
export { ForwardRef as ReactComponent };